/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rec{position:relative;height:100%;padding:0 0 60px;-webkit-box-sizing:border-box;box-sizing:border-box}.rec__header,.rec__toolbar{position:absolute;left:0;width:100%}.rec__header{top:0;line-height:30px;padding:20px 0}.rec__toolbar{bottom:0;height:60px;background:#fff}.rec__content{height:100%;overflow:auto}.rec--no-record .hide-on-no-record,.rec--playback .hide-on-playback,.rec--recording .hide-on-recording,.rec--single-layer .hide-on-single-layer{visibility:hidden}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/rec.component.styl.ngstyle.js.pre-build-optimizer.js